// import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
// import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
// import { SwalComponent } from '@sweetalert2/ngx-sweetalert2';
// import { ToastrService } from 'ngx-toastr';
// import { AuthService } from 'src/app/services/auth.service';
// import { LocationService } from 'src/app/services/location.service';
// import { SubscriptionService } from 'src/app/services/subscription.service';
// import { environment } from 'src/environments/environment';
// @Component({
//   selector: 'app-footer',
//   templateUrl: './footer.component.html',
//   styleUrls: ['./footer.component.scss']
// })
// export class FooterComponent implements OnInit, AfterViewInit {
//   adminAppUrl: string = environment.adminAppUrl;
//   @ViewChild('confirmSwalRappel') private confirmSwalRappel: SwalComponent;
//   @ViewChild('confirmSwalSinistre') private confirmSwalSinistre: SwalComponent;
//   @ViewChild('closeBTNRappel') closeBTNRappel: ElementRef;
//   fieldsRappel = [{
//     label: "Nom",
//     field: "nom",
//     icon: "assets/images/nom.svg",
//     type: "text",
//     isRequired: true,
//     validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
//   }, {
//     label: "Prénom",
//     field: "prenom",
//     icon: "assets/images/nom.svg",
//     type: "text",
//     isRequired: true,
//     validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
//   }, {
//     label: "Email",
//     field: "email",
//     icon: "assets/images/icon-email.svg",
//     type: "email",
//     isRequired: true,
//     validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }, { name: "pattern", value: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/, message: "Ce champ est invalide" }]
//   },
//   {
//     label: "Téléphone",
//     field: "telephone",
//     icon: "assets/images/telephone.svg",
//     type: "tel",
//     isRequired: true,
//     validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
//   },
//   {
//     label: "Disponibilité",
//     field: "disponibilite",
//     icon: "assets/images/icon-date.svg",
//     type: "select",
//     isRequired: true,
//     list:[{name:'Matin',value:'Matin'},{name:'Soir',value:'Soir'},{name:'Toute la journée',value:'Toute la journée'}],
//     validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
//   }, {
//     label: "Quelle heure",
//     field: "heure",
//     icon: "assets/images/icon-date.svg",
//     type: "select",
//     isRequired: false,
//     chieldOther: { name: 'disponibilite', value:"Matin" },
//     list: [{ name: '08H-10H', value: "08H-10H" }, { name: "10H-12H", value: "10H-12H" }, { name: "12H-14H", value: "12H-14H" }],
//     validations: []
//   }, {
//     label: "Quelle heure",
//     field: "heure",
//     icon: "assets/images/icon-date.svg",
//     type: "select",
//     isRequired: false,
//     chieldOther: { name: 'disponibilite', value:"Soir" },
//     list: [{ name: '15H-16H', value: "15hH-16H" }, { name: "16H-17H", value: "16H-17H" }, { name: "17H-18H", value: "17H-18H" }],
//     validations: []
//   }];
//   fieldsSinistre = [{
//     label: "Téléphone",
//     field: "telephone",
//     icon: "assets/images/telephone.svg",
//     type: "tel",
//     isRequired: true,
//     validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
//   }, {
//     label: "Numéro sinistre",
//     field: "numero",
//     icon: "assets/images/icon-carte-grise.svg",
//     type: "text",
//     isRequired: true,
//     validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
//   }];
//   currentPays = "Senegal";
//   loader:boolean = false;
//   firstClick:boolean = false;
//   formRappel:FormGroup;
//   formSinistre:FormGroup;
//   hasPhoneError: boolean;
//   isFocus: unknown;
//   infoSinistre:any;
//   country: string | null = null;
//   filiales = [];
//   currentFiliale : any;
//   constructor(private toastr: ToastrService,
//      private authService: AuthService,
//      private subscriptionService:SubscriptionService,
//      private locationService: LocationService
//     ) {
//     // this.getLocationFromIP()
//    }

//   ngOnInit(): void {
//     this.initRappel();
//     this.initSinistre();
//     this.subscribeToLocationData();
//   }


//    /**
//    * S'abonner aux données du service de localisation
//    */
//   subscribeToLocationData(): void {
//     // S'abonner à la filiale courante
//     this.locationService.currentFiliale$.subscribe(filiale => {
//       this.currentFiliale = filiale;
//     });

//     // S'abonner à la liste des filiales
//     this.locationService.filiales$.subscribe(filiales => {
//       this.filiales = filiales;
//     });
//   }

//   ngAfterViewInit(): void{
//     // this.getFiliales();
//   }


//   initRappel() {
//     this.firstClick = false;
//     this.formRappel = new FormGroup(this.getForm(this.fieldsRappel));
//   }
//   initSinistre() {
//     this.firstClick = false;
//     this.formSinistre = new FormGroup(this.getForm(this.fieldsSinistre));
//   }
//   getForm(fields) {
//     let group = {};
//     for (let element of fields) {
//       let tabValidation = []
//       if (element.isRequired && element.validations.length != 0) {
//         for (let validation of element.validations) {
//           if (validation.name == 'required' && validation.value) {
//             tabValidation.push(Validators.required);
//           }
//           if (validation.name == 'minlength' && validation.value != '') {
//             tabValidation.push(Validators.minLength(validation.value));
//           }
//           if (validation.name == 'maxlength' && validation.value != '') {
//             tabValidation.push(Validators.maxLength(validation.value));
//           }
//           if (validation.name == 'max' && validation.value != '') {
//             tabValidation.push(Validators.max(validation.value));
//           }
//           if (validation.name == 'min' && validation.value != '') {
//             tabValidation.push(Validators.min(validation.value));
//           }
//           if (validation.name == 'pattern' && validation.value != '') {
//             tabValidation.push(Validators.pattern(validation.value));
//           }
//         }
//       }
//       if (element.type == 'checkbox')
//         group[element.field] = new FormArray([], tabValidation);
//       else
//         group[element.field] = new FormControl('', tabValidation);
//     }
//     return group;
//   }
//   checkFormRappel() {
//     if (this.formRappel.invalid || this.hasPhoneError) {
//       this.firstClick = true;
//     } else {
//       this.firstClick = false;
//       this.confirmSwalRappel.fire();
//     }
//   }
//   checkFormSinistre() {
//     if (this.formSinistre.invalid || this.hasPhoneError) {
//       this.firstClick = true;
//     } else {
//       this.firstClick = false;
//       this.confirmSwalSinistre.fire();
//     }
//   }
//   saveRappel() {
//     this.loader = true;
//     let value = this.formRappel.value;
//     let data = {
//       "contains": JSON.stringify(value),
//       "pays":this.currentPays
//     }
//     this.authService.saveRappel(data).subscribe(resp => {
//       if (resp['responseCode'] == 200) {
//         this.loader = false;
//         this.toastr.success('Formulaire envoyée avec succès', 'Succès');
//         this.closeBTNRappel.nativeElement.click();
//       } else {
//         this.loader = false;
//         this.toastr.error(resp['errors'][0]['message']);
//       }
//     }, error => {
//       this.loader = false;
//       this.toastr.error(error['error']['errors'][0]['message'], 'Erreur !!!');
//     });

//   }
//   checkSuiviSinistre() {
//     this.infoSinistre=null;
//     this.loader = true;
//     this.authService.checkSinistre(this.formSinistre.value).subscribe(resp => {
//       if (resp['responseCode'] == 200) {
//         this.loader = false;
//         this.infoSinistre=resp['data'];
//         // this.toastr.success('Formulaire envoyée avec succès', 'Succès');
//         // this.closeBTNRappel.nativeElement.click();
//       } else {
//         this.infoSinistre=null;
//         this.loader = false;
//         this.toastr.error(resp['errors'][0]['message']);
//       }
//     }, error => {
//       this.infoSinistre=null;
//       this.loader = false;
//       this.toastr.error(error['error']['errors'][0]['message'], 'Erreur !!!');
//     });

//   }
//   hasError(ev,field,form) {
//     this.hasPhoneError = !ev ? true : false;
//     let currentValue = this[form].get(field).value;
//     if (this.currentPays == 'Côte d’Ivoire' && this.hasPhoneError) {
//       if (currentValue != '') {
//         if (currentValue.includes("+225") && currentValue.length != 14) {
//           this.hasPhoneError = true;
//           let val = currentValue.replace('+225', '');
//           this[form].get(field).setValue(val);
//         } else if (currentValue.length == 10 && !currentValue.includes("+225")) {
//           this.hasPhoneError = false;
//           let value = '+225' + currentValue;
//           this[form].get(field).setValue(value);
//         } else if (currentValue.includes("+225") && currentValue.length == 14) {
//           let val = currentValue.replace('+225', '');
//           this[form].get(field).setValue(val);
//           this.hasPhoneError = false;
//         }
//       }
//     } else if (this.currentPays == 'Côte d’Ivoire' && !this.hasPhoneError){
//       let val = currentValue.replace('+225', '');
//       this[form].get(field).setValue(val);
//       this.hasPhoneError = true;
//     }
//   }

//   getNumber(ev, field,form) {
//     if(this.currentPays!='Côte d’Ivoire')
//       this[form].get(field).setValue(ev);
//   }
//   telInputObject(ev) {
//     // console.log("telNUm-EV",ev);
//   }

//   onCountryChange(ev) {
//     let value = ev['name'].toString();
//     let val = "";
//     for (let i = 0; i < value.length; i++) {
//       if (value[i] == '(') {
//         val = value.substring(0, i - 1);
//         this.currentPays = val;

//       } else {
//         this.currentPays = value;
//       }
//     }

//   }
//   getRoute(route,type){
//     localStorage.setItem('route',route);
//     localStorage.setItem('sectionShown',type);
//   }

// }


import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import { SwalComponent } from '@sweetalert2/ngx-sweetalert2';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from 'src/app/services/auth.service';
import { LocationService } from 'src/app/services/location.service';
import { SubscriptionService } from 'src/app/services/subscription.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit, AfterViewInit {
  adminAppUrl: string = environment.adminAppUrl;
  @ViewChild('confirmSwalRappel') private confirmSwalRappel: SwalComponent;
  @ViewChild('confirmSwalSinistre') private confirmSwalSinistre: SwalComponent;
  @ViewChild('closeBTNRappel') closeBTNRappel: ElementRef;
  
  fieldsRappel = [{
    label: "Nom",
    field: "nom",
    icon: "assets/images/nom.svg",
    type: "text",
    isRequired: true,
    validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
  }, {
    label: "Prénom",
    field: "prenom",
    icon: "assets/images/nom.svg",
    type: "text",
    isRequired: true,
    validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
  }, {
    label: "Email",
    field: "email",
    icon: "assets/images/icon-email.svg",
    type: "email",
    isRequired: true,
    validations: [
      { name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" },
      { name: "pattern", value: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/, message: "Ce champ est invalide" }
    ]
  }, {
    label: "Téléphone",
    field: "telephone",
    icon: "assets/images/telephone.svg",
    type: "tel",
    isRequired: true,
    validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
  }, {
    label: "Disponibilité",
    field: "disponibilite",
    icon: "assets/images/icon-date.svg",
    type: "select",
    isRequired: true,
    list: [
      { name: 'Matin', value: 'Matin' },
      { name: 'Soir', value: 'Soir' },
      { name: 'Toute la journée', value: 'Toute la journée' }
    ],
    validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
  }, {
    label: "Quelle heure",
    field: "heure",
    icon: "assets/images/icon-date.svg",
    type: "select",
    isRequired: false,
    chieldOther: { name: 'disponibilite', value: "Matin" },
    list: [
      { name: '08H-10H', value: "08H-10H" },
      { name: "10H-12H", value: "10H-12H" },
      { name: "12H-14H", value: "12H-14H" }
    ],
    validations: []
  }, {
    label: "Quelle heure",
    field: "heure",
    icon: "assets/images/icon-date.svg",
    type: "select",
    isRequired: false,
    chieldOther: { name: 'disponibilite', value: "Soir" },
    list: [
      { name: '15H-16H', value: "15H-16H" },
      { name: "16H-17H", value: "16H-17H" },
      { name: "17H-18H", value: "17H-18H" }
    ],
    validations: []
  }];
  
  fieldsSinistre = [{
    label: "Téléphone",
    field: "telephone",
    icon: "assets/images/telephone.svg",
    type: "tel",
    isRequired: true,
    validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
  }, {
    label: "Numéro sinistre",
    field: "numero",
    icon: "assets/images/icon-carte-grise.svg",
    type: "text",
    isRequired: true,
    validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
  }];
  
  currentPays = "Senegal";
  loader: boolean = false;
  firstClick: boolean = false;
  formRappel: FormGroup;
  formSinistre: FormGroup;
  hasPhoneError: boolean;
  isFocus: unknown;
  infoSinistre: any;
  country: string | null = null;
  filiales = [];
  currentFiliale: any;
  isDataLoaded: boolean = false;

  constructor(
    private toastr: ToastrService,
    private authService: AuthService,
    private subscriptionService: SubscriptionService,
    private locationService: LocationService
  ) {}

  ngOnInit(): void {
    this.initRappel();
    this.initSinistre();
    this.subscribeToLocationData();
  }

  /**
   * S'abonner aux données du service de localisation
   */
  subscribeToLocationData(): void {
    // S'abonner au statut de chargement
    this.locationService.isLoaded$.subscribe(isLoaded => {
      this.isDataLoaded = isLoaded;
    });

    // S'abonner à la filiale courante
    this.locationService.currentFiliale$.subscribe(filiale => {
      if (filiale) {
        this.currentFiliale = filiale;
      }
    });

    // S'abonner à la liste des filiales
    this.locationService.filiales$.subscribe(filiales => {
      if (filiales && filiales.length > 0) {
        this.filiales = filiales;
      }
    });
  }

  ngAfterViewInit(): void {
    // Plus besoin d'appeler getFiliales ici
  }

  initRappel() {
    this.firstClick = false;
    this.formRappel = new FormGroup(this.getForm(this.fieldsRappel));
  }

  initSinistre() {
    this.firstClick = false;
    this.formSinistre = new FormGroup(this.getForm(this.fieldsSinistre));
  }

  getForm(fields) {
    let group = {};
    for (let element of fields) {
      let tabValidation = [];
      if (element.isRequired && element.validations.length != 0) {
        for (let validation of element.validations) {
          if (validation.name == 'required' && validation.value) {
            tabValidation.push(Validators.required);
          }
          if (validation.name == 'minlength' && validation.value != '') {
            tabValidation.push(Validators.minLength(validation.value));
          }
          if (validation.name == 'maxlength' && validation.value != '') {
            tabValidation.push(Validators.maxLength(validation.value));
          }
          if (validation.name == 'max' && validation.value != '') {
            tabValidation.push(Validators.max(validation.value));
          }
          if (validation.name == 'min' && validation.value != '') {
            tabValidation.push(Validators.min(validation.value));
          }
          if (validation.name == 'pattern' && validation.value != '') {
            tabValidation.push(Validators.pattern(validation.value));
          }
        }
      }
      if (element.type == 'checkbox')
        group[element.field] = new FormArray([], tabValidation);
      else
        group[element.field] = new FormControl('', tabValidation);
    }
    return group;
  }

  checkFormRappel() {
    if (this.formRappel.invalid || this.hasPhoneError) {
      this.firstClick = true;
    } else {
      this.firstClick = false;
      this.confirmSwalRappel.fire();
    }
  }

  checkFormSinistre() {
    if (this.formSinistre.invalid || this.hasPhoneError) {
      this.firstClick = true;
    } else {
      this.firstClick = false;
      this.confirmSwalSinistre.fire();
    }
  }

  saveRappel() {
    this.loader = true;
    let value = this.formRappel.value;
    let data = {
      "contains": JSON.stringify(value),
      "pays": this.currentPays
    };
    
    this.authService.saveRappel(data).subscribe(resp => {
      if (resp['responseCode'] == 200) {
        this.loader = false;
        this.toastr.success('Formulaire envoyé avec succès', 'Succès');
        this.closeBTNRappel.nativeElement.click();
      } else {
        this.loader = false;
        this.toastr.error(resp['errors'][0]['message']);
      }
    }, error => {
      this.loader = false;
      this.toastr.error(error['error']['errors'][0]['message'], 'Erreur !!!');
    });
  }

  checkSuiviSinistre() {
    this.infoSinistre = null;
    this.loader = true;
    
    this.authService.checkSinistre(this.formSinistre.value).subscribe(resp => {
      if (resp['responseCode'] == 200) {
        this.loader = false;
        this.infoSinistre = resp['data'];
      } else {
        this.infoSinistre = null;
        this.loader = false;
        this.toastr.error(resp['errors'][0]['message']);
      }
    }, error => {
      this.infoSinistre = null;
      this.loader = false;
      this.toastr.error(error['error']['errors'][0]['message'], 'Erreur !!!');
    });
  }

  hasError(ev, field, form) {
    this.hasPhoneError = !ev ? true : false;
    let currentValue = this[form].get(field).value;
    
    if (this.currentPays == "Côte d'Ivoire" && this.hasPhoneError) {
      if (currentValue != '') {
        if (currentValue.includes("+225") && currentValue.length != 14) {
          this.hasPhoneError = true;
          let val = currentValue.replace('+225', '');
          this[form].get(field).setValue(val);
        } else if (currentValue.length == 10 && !currentValue.includes("+225")) {
          this.hasPhoneError = false;
          let value = '+225' + currentValue;
          this[form].get(field).setValue(value);
        } else if (currentValue.includes("+225") && currentValue.length == 14) {
          let val = currentValue.replace('+225', '');
          this[form].get(field).setValue(val);
          this.hasPhoneError = false;
        }
      }
    } else if (this.currentPays == "Côte d'Ivoire" && !this.hasPhoneError) {
      let val = currentValue.replace('+225', '');
      this[form].get(field).setValue(val);
      this.hasPhoneError = true;
    }
  }

  getNumber(ev, field, form) {
    if (this.currentPays != "Côte d'Ivoire")
      this[form].get(field).setValue(ev);
  }

  telInputObject(ev) {
    // console.log("telNUm-EV", ev);
  }

  onCountryChange(ev) {
    let value = ev['name'].toString();
    let val = "";
    for (let i = 0; i < value.length; i++) {
      if (value[i] == '(') {
        val = value.substring(0, i - 1);
        this.currentPays = val;
      } else {
        this.currentPays = value;
      }
    }
  }

  getRoute(route, type) {
    localStorage.setItem('route', route);
    localStorage.setItem('sectionShown', type);
  }
}
